function parsePositivePage(value: unknown): number | null {
  if (typeof value === "number") {
    return Number.isInteger(value) && value > 0 ? value : null
  }

  if (typeof value !== "string") {
    return null
  }

  const trimmed = value.trim()
  if (!trimmed || !/^\d+$/.test(trimmed)) {
    return null
  }

  const parsed = Number.parseInt(trimmed, 10)
  return parsed > 0 ? parsed : null
}

function formatPageRange(start: number, end: number): string {
  const normalizedStart = Math.min(start, end)
  const normalizedEnd = Math.max(start, end)

  if (normalizedStart === normalizedEnd) {
    return String(normalizedStart)
  }

  return `${normalizedStart}-${normalizedEnd}`
}

function compactPages(values: Array<number | null>): number[] {
  return values.filter((value): value is number => value !== null)
}

export function normalizeSourcePages(value: unknown): string {
  if (Array.isArray(value)) {
    const pages = compactPages(value.map(parsePositivePage))
    if (pages.length === 0) {
      return ""
    }
    return formatPageRange(pages[0], pages[pages.length - 1])
  }

  const singlePage = parsePositivePage(value)
  if (singlePage !== null) {
    return String(singlePage)
  }

  if (typeof value !== "string") {
    return ""
  }

  const trimmed = value.trim()
  if (!trimmed || !trimmed.includes("-")) {
    return ""
  }

  const pages = compactPages(trimmed.split("-").map((part) => parsePositivePage(part)))
  if (pages.length === 0) {
    return ""
  }

  return formatPageRange(pages[0], pages[pages.length - 1])
}

export function getSourcePageNumber(value: unknown, fallbackPage = 1): number {
  const pageParam = normalizeSourcePages(value) || String(fallbackPage)
  const pageNumber = Number.parseInt(pageParam.split("-")[0], 10)
  return Number.isInteger(pageNumber) && pageNumber > 0 ? pageNumber : fallbackPage
}
